import { useState } from 'react';
import FeedbackModal from './FeedbackModal';

/**
 * 피드백 플로팅 버튼
 * 화면 우하단에 고정, 클릭 시 피드백 모달 오픈
 */
export default function FeedbackButton() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* 플로팅 버튼 */}
      <button
        onClick={() => setIsOpen(true)}
        className="fixed bottom-20 right-4 z-40 w-12 h-12 bg-primary-600 hover:bg-primary-700 rounded-full shadow-lg flex items-center justify-center transition-all hover:scale-110"
        aria-label="피드백 보내기"
      >
        <span className="text-xl">💬</span>
      </button>

      {/* 피드백 모달 */}
      <FeedbackModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
